/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const kurashi: CommunityData = {
  code: "kurashi",
  inviteCode: "kurashi",
  name: "Kurashi",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/kurashi`,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "/assets/customizations/kurashi/logo.png",
        styles: "w-[122px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/kurashi/logo-2.png",
        styles: "w-[122px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[1px] border-[#000000]",
      bgColor: "#F6F4E7",
      asideBg: "#F6F4E7",
      asideStyles: "border-r-[#000000] border-r",
      contentBg: "#F6F4E7",
      bgDesktop: "/assets/customizations/kurashi/bg.png",
      bgMobile: "/assets/customizations/kurashi/bg.png",
      mainFont: "font-['SnellRoundhandScript']",
      primaryButton:
        "flex mt-2 !text-[#000] !font-['CrimsonText'] rounded-full justify-center items-center !text-[20px] pt-1 !h-[50px] bg-[#F6F4E7] border-[#000] border-[1px] !px-[32px] sm:!min-w-[156px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-t-[#000000] border-t",
      item: "text-[24px] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-1 !pt-5",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[40px] leading-[50px] ml-[10px]",
      announcements: {
        lg: {
          title:
            "!text-[14px] -mb-1 font-['BaskervilleBT'] !bg-[#000] mt-[-4px] px-[6px] w-fit h-[19px] flex items-center",
          subtitle:
            "!text-[14px] px-[6px] font-['CrimsonText'] !bg-[#FFFFFF] !text-[#000000] w-fit h-[19px] flex items-center",
        },
        sm: {
          title:
            "!text-[14px] mb-[3px] font-['BaskervilleBT'] !bg-[#000] mt-[-4px] px-[6px] w-fit h-[19px] flex items-center",
          subtitle:
            "!text-[14px] px-[6px] font-['CrimsonText'] !bg-[#FFFFFF] !text-[#000000] w-fit h-[19px] flex items-center",
        },
      },
      event: {
        title: "text-[22px] one-line-truncate font-['BaskervilleBT']",
        subtitle: "text-[16px] leading-[18px] font-['CrimsonText']",
      },
      shop: {
        title: "text-[22px] font-['BaskervilleBT']",
        text: "text-[16px] leading-[20px] font-['CrimsonText']",
        customShopImage: "",
      },
      emptyOrLoadingState: "text-[#000] text-[14px]",
    },
    announcements: {
      created: "text-[16px] leading-[20px] font-['CrimsonText']",
      emptyOrLoadingState: "text-[#000] text-[14px]",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[40px] leading-[50px] ml-[10px]",
      title: "text-[24px] font-['BaskervilleBT']",
      description: "text-[16px] leading-[20px] font-['CrimsonText']",
    },
    announcement: {
      likeCount: "text-[#000]",
      commentCount: "text-[#000]",
      created: "text-[16px] leading-[20px] font-['CrimsonText']",
      emptyOrLoadingState: "text-[#000] text-[14px]",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "text-[24px] font-['BaskervilleBT']",
      description: "text-[16px] leading-[20px] font-['CrimsonText']",
      commentIconColor: "#000",
      likeIconColor: "#000",
    },
    events: {
      sectionHeader: "text-[28px] font-['BaskervilleBT'] leading-[27px]",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[40px] leading-[50px] ml-[10px]",
      title: "text-[24px] font-['BaskervilleBT']",
      emptyOrLoadingState: "text-[#000] text-[14px]",
      duration: "text-[16px] leading-[20px] font-['CrimsonText']",
      address: "text-[16px] leading-[20px] font-['CrimsonText']",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#000]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[#000] text-[14px]",
      header: "text-[32px] font-['BaskervilleBT'] leading-[45px] !mt-0 sm:mb-0 mb-[24px]",
      sectionTitle: "text-[28px] font-['BaskervilleBT'] leading-[27px]",
      sectionSubtitle: "!text-[20px] leading-[26px] font-['CrimsonText']",
      text: "text-[16px] leading-[20px] font-['CrimsonText']",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#000]",
      map: {
        pin: "",
        border: "mb-2 border-[1px] border-[#FFFFFF] overflow-hidden",
        pinColor: "#FBE201",
        strokeColor: "#FBE201",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "!mt-0 text-[32px] font-['BaskervilleBT'] leading-[45px]",
        subtitle: "!text-[20px] leading-[26px] font-['CrimsonText']",
      },
      ticket: {
        title: "text-[24px] font-['BaskervilleBT']",
        description: "font-['CrimsonText'] text-[20px] leading-[26px]",
        text: "font-['CrimsonText'] text-[16px] leading-[20px]",
        price: "text-[24px] font-['BaskervilleBT']",
        counterContainer: "text-[20px] !text-[#000] !border-[#000]",
        quantity: "text-nowrap text-[#000] text-[16px] !border-[#000] font-['CrimsonText']",
      },
      separator: "sm:my-8 my-6 border-b-[#000] border-b-[1px]",
    },
    shop: {},
    linktree: {
      container:
        "font-['BaskervilleBT'] flex flex-col items-center h-full w-full bg-cover min-h-screen relative bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/kurashi/bg-linktree.png",
      bgMobile: "/assets/customizations/kurashi/bg-linktree.png",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[#FFFFFF] border-[2px]",
        name: "text-[32px] mt-2",
        location: "text-[20px] mb-2 font-['CrimsonText']",
        description: "text-[15px] font-['CrimsonText'] leading-[20px] text-center mb-4",
        socialMediaIconColor: "#000",
        button:
          "flex px-[32px] rounded-full font-['CrimsonText'] justify-center items-center !text-[20px] !h-[50px] bg-[#F6F4E7] border-[#000000] border-[1px] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[42px] border-[2px] border-[#000] !h-[56px] sm:w-[500px] w-[95vw] p-4 flex bg-[#F6F4E7] font-['BaskervilleBT'] items-center text-[20px]",
        emptyState: {
          container:
            "border-[#000] border-[1px] sm:w-[500px] w-[95vw] bg-[#F6F4E7] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title:
            "text-[16px] leading-[20px] sm:w-[390px] w-[65vw] text-center font-['CrimsonText']",
          text: "text-[14px] font-['BaskervilleBT'] mb-4",
          button:
            "flex px-[16px] w-fit font-['CrimsonText'] rounded-full justify-center items-center !text-[16px] !h-[29px] bg-[#F6F4E7] border-[1px] border-[#000] text-nowrap cursor-pointer",
        },
        header: "text-[28px] font-['BaskervilleBT'] mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        collapsedEvent: {
          container:
            "h-[64px] border-[#000] border-[1px] bg-[#F6F4E7] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          duration: "text-[14px] font-['CrimsonText']",
          name: "text-[20px] leading-[20px] font-['BaskervilleBT'] sm:w-[390px] w-[65vw]",
          plusIconColor: "#000",
          media: "overflow-hidden m-2",
        },
        event: {
          container:
            "overflow-hidden border-[#000] border-[1px] bg-[#F6F4E7] sm:w-[500px] w-[95vw]",
          name: "text-[16px] leading-[20px] mb-1 sm:w-[390px] w-[65vw]",
          startDate:
            "!w-[64px] text-[#F6F4E7] text-[24px] h-[64px] bg-[#000] flex flex-col justify-center items-center gap-1 font-black font-['Swiss']",
          duration: "text-[12px] uppercase",
          location: "text-[12px] mb-4",
          button:
            "flex px-[16px] w-fit font-['CrimsonText'] rounded-full justify-center items-center !text-[16px] !h-[29px] bg-[#F6F4E7] border-[1px] border-[#000] text-nowrap cursor-pointer",
          product: {
            container: "h-[74px] border-t border-t-[#000] px-4 items-center flex justify-between",
            name: "text-[20px] leading-[20px] mb-1 one-line-truncate sm:w-[390px] w-[65vw] font-['BaskervilleBT']",
            price: "text-[14px] font-['CrimsonText']",
            status: "text-[16px] font-['CrimsonText']",
            link: "text-[14px] font-['CrimsonText']",
            button:
              "flex px-[16px] font-['CrimsonText'] w-fit rounded-full justify-center items-center !text-[16px] !h-[29px] bg-[#F6F4E7] border-[1px] border-[#000] text-nowrap cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[14px] underline font-['CrimsonText'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[42px] border-[2px] border-[#000] !h-[56px] sm:w-[500px] w-[95vw] p-4 flex bg-[#F6F4E7] font-['BaskervilleBT'] items-center text-[20px]",
        header: "text-[28px] font-['BaskervilleBT'] mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden bg-[#F6F4E7] border-[1px] border-[#000] h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          name: "font-['BaskervilleBT'] mt-[2px] text-[20px] leading-[24px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created: "text-[14px] mt-[-7px] font-['CrimsonText']",
          media: "overflow-hidden m-2",
        },
        seeAllNews:
          "text-[14px] underline font-['CrimsonText'] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[42px] border-[2px] border-[#000] !h-[56px] sm:w-[500px] w-[95vw] p-4 flex bg-[#F6F4E7] font-['BaskervilleBT'] items-center text-[20px]",
        header: "text-[28px] font-['BaskervilleBT'] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[56px] border-[1px] border-[#000000] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#F6F4E7]",
          name: "text-[20px] font-['BaskervilleBT'] leading-[20px] mb-[6px] mt-[8px] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full border border-[#000] object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#000",
        text: "uppercase font-mono text-[11px] font-bold text-[#000]",
      },
    },
  },
}

export default kurashi
